import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { GET_WATTAGE, GET_TEMPERATURE, GET_DISTRIBUTION, GET_OPTION, GET_PLATESTYLE } from "../../../services/graphql-query";

const OrderGuide = () => {

    const category = window.localStorage.getItem("category");
    const collection = window.localStorage.getItem("product_name");

    const wattage = useQuery(GET_WATTAGE, { variables: { category: category, collection: collection } });
    const temperatures = useQuery(GET_TEMPERATURE, { variables: { collection: collection } });
    const plateStyle = useQuery(GET_PLATESTYLE, { variables: { category: category, collection: collection } });
    const distributions = useQuery(GET_DISTRIBUTION, { variables: { category: category, collection: collection } });
    const options = useQuery(GET_OPTION, { variables: { category: category, collection: collection } });

    let wattageData = [];
    let temperatureData = [];
    let plateStyleData = [];
    let distributionData = [];
    let optionData = [];
    if (wattage?.data) {
        wattageData = wattage.data.wattages.data;
    }
    if (temperatures?.data) {
        temperatureData = temperatures.data.temperatures.data;
    }
    if (plateStyle?.data) {
        plateStyleData = plateStyle.data.plateStyles.data;
    }
    if (distributions?.data) {
        distributionData = distributions.data.distributions.data;
    }
    if (options?.data) {
        optionData = options.data.options.data;
    }

    return (
        <div className="order-guide mt-5">
            <div className="order-guide-items">
                <div className="wattage-table order-guide-item">
                    <div className="order-guide-title">{collection}-Wattage</div>
                    <div className="guide-items mt-4">
                        {wattageData.length ? wattageData.map((item, index) => (
                            <div key={index} className="guide-content">
                                <p>{item?.attributes?.product?.data?.attributes?.title}</p>
                                <p>{item?.attributes?.Watt}W</p>
                            </div>
                        )) : "N/A"}
                    </div>
                </div>
                <div className="temperature-table order-guide-item">
                    <div className="color-temperature">Color Temperature</div>
                    <div className="guide-items mt-4">
                        {temperatureData.length ? temperatureData.map((item, index) => (
                            <div key={index} className="guide-content">
                                <p>{item?.attributes?.key_temperature}</p>
                                <p>{item?.attributes?.value_temperature}</p>
                            </div>
                        )) : "N/A"}
                    </div>
                </div>
                <div className="plate-table order-guide-item">
                    <div className="order-guide-title">Plate Style</div>
                    <div className="guide-items mt-4">
                        {plateStyleData.length ? plateStyleData.map((item, index) => (
                            <div key={index} className="guide-content">
                                <p>{item?.attributes?.Abbreviation}</p>
                                <p>{item?.attributes?.Name}</p>
                            </div>
                        )) : "N/A"}
                    </div>
                </div>
                <div className="distribution-table order-guide-item">
                    <div className="order-guide-title">Distribution</div>
                    <div className="guide-items mt-4">
                        {distributionData.length ? distributionData.map((item, index) => (
                            <div key={index} className="guide-content-div">
                                <p className="guide-title">{item?.attributes?.Abbreviation}</p>
                                <p className="pl-2">{item?.attributes?.Name}</p>
                            </div>
                        )) : "N/A"}
                    </div>
                </div>
                <div className="option-table order-guide-item">
                    <div className="order-guide-title">Options</div>
                    <div className="guide-items mt-4">
                        {optionData.length ? optionData.map((item, index) => (
                            <div key={index} className="guide-content-div">
                                <p className="guide-title">{item?.attributes?.Abbreviation}</p>
                                <p className="pl-2">{item?.attributes?.Name}</p>
                            </div>
                        )) : "N/A"}
                    </div>
                </div>
            </div>
            <div className="order-guide-note mt-4">
                <span>Note:</span>
                <p>Custom Plate designs must be submitted prior to final quote release.</p>
            </div>
        </div>
    )
}

export default OrderGuide;